import _ from "lodash";
import moment from "moment-timezone";

const timezoneList = () => {
  const timezones = moment.tz.names();

  const timezoneList = timezones.map((zone, index) => {
    const offset = moment.tz(zone).format("Z"); // Get the current UTC offset considering DST
    const label = _.replace(zone, /\//g, " - ");
    const timezone = `GMT${offset}`;

    return {
      id: index + 1,
      zone,
      label: `(${timezone}) ${label}`,
      timezone,
    };
  });

  return _.sortBy(timezoneList, "label");
};

export const getTimezoneList = () => {
  return _.map(timezoneList(), ({ label, zone }) => {
    return { value: zone, label };
  });
};

export const getGlobalTimezone = () => {
  const globalTimezone = moment().tz();
  return _.isEmpty(globalTimezone) ? moment.tz.guess() : globalTimezone;
};

export const convertMomentToAdjustedDate = momentObj => {
  const momentOffset = momentObj.utcOffset();
  const systemOffset = moment.tz(moment.tz.guess()).utcOffset();
  const offsetDifference = momentOffset - systemOffset;
  const adjustedMoment = momentObj.clone().add(offsetDifference, "minutes");
  return adjustedMoment.toDate();
};

export const getTimezoneByValue = value => {
  const { name } = moment.tz.zone(value) || {};

  const offset = moment.tz(name).format("Z"); // Get the current UTC offset considering DST
  const formattedLabel = _.replace(name, /\//g, " - ");
  const timezone = `GMT${offset}`;
  const labelWithTimezone = `(${timezone}) ${formattedLabel}`;

  return {
    value: name,
    label: labelWithTimezone,
  };
};
